const MAX_WIDTH = 1600;
const WEBP_QUALITY = 0.85;

export type CompressImageForNoteResult = {
  blob: Blob;
  contentType: 'image/webp';
  byteLength: number;
};

function loadImageFromBlob(blob: Blob): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to decode image'));
    };
    img.src = url;
  });
}

/** Resize wide images and encode as WebP for note media upload. */
export async function compressImageForNote(input: Blob): Promise<CompressImageForNoteResult> {
  const img = await loadImageFromBlob(input);
  const scale = img.width > MAX_WIDTH ? MAX_WIDTH / img.width : 1;
  const width = Math.max(1, Math.round(img.width * scale));
  const height = Math.max(1, Math.round(img.height * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas not available');
  ctx.drawImage(img, 0, 0, width, height);
  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error('WebP encode failed'))),
      'image/webp',
      WEBP_QUALITY
    );
  });
  return { blob, contentType: 'image/webp', byteLength: blob.size };
}
